export default "__VITE_ASSET__CkKA6Lt4__"